import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_SCANNER_API_URL || "/scanner-api",
    withCredentials: true,
});

instance.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error)
);

export default instance;
